import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

const getClinicPartnerAvgNpsQueryKey = () => ["getClinicPartnerAvgNps"] as const;

export const useGetClinicPartnerAvgNps = () => {
  const client = useApiClient();

  return useQuery(getClinicPartnerAvgNpsQueryKey(), () => client.getClinicPartnerAvgNps());
};
